module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/deodorant_1f1dc9.png";